<template>
<div class="home">
  <div class="home hero">
    <div class="hero-body"><h1 class="is-size-1 is-size-2-mobile">Konstnärliga scener må vara hotade <br>– men konstnärskapet behöver inte vara det.</h1>
      <p class="is-size-5 mt-5">Detta är ett projekt som gör det enkelt att stödja en konstnär med ett finansiellt bidrag.</p>
    </div>
  </div>
  <div class="container mt-5">
      <div class="section has-background-grey-light py-2">
        <h2 class="is-size-5 has-text-white">Några anslutna konstnärer</h2>
      </div>
    
    <div class="columns">
    <div v-for="a of artists" v-bind:key="a.slug" class="column">
      <div class="card my-5">
        <div class="card-content">
          <p class="is-size-7">{{a.title}}</p>
      <a class="has-text-link" v-bind:href="'/a/' +a.slug">{{a.firstName}} {{a.lastName}}</a>
      </div>
      </div>
    </div>
    </div>
  </div>
</div>
</template>

<script>
export default {
  name: 'Home',
  components: {
  },
  data: function() {
    return {
      artists: [
        {
          name: "Demo",
          city: "Sörfors",
          homepage: "Vonkonst.se",
          accountId: "acct_1HDmewGAZPe29ZH1",
          firstName: "Demo",
          lastName: "von Konstnär",
          title: "Målare",
          slug: "demo-von-konstnar"
        },
        {
          name: "",
          city: "Test",
          homepage: "hdbg.se",
          accountId: "acct_1HDmGKF12doQ8Yp2",
          firstName: "Simpa ",
          lastName: "Doodle",
          title: "Performancekonstnär",
          slug: "simpa-doodle"
        },
        {
          city: "Umeå",
          firstName: "PA",
          lastName: "Hellberg",
          homepage: "http://hdbg.se/",
          title: "Konstnär",
          slug: "pa-hellberg",
        }
    ]
    }
  }
}
</script>
